<template>
  <div class="map">
    <div class="app-container">
      <div id="chinaMap"></div>
      <div class="mapChoose">
        <span v-for="(item, index) in parentInfo" :key="item.code">
          <span class="title" @click="chooseArea(item, index)">{{
            item.cityName == "全国" ? "中国" : item.cityName
          }}</span>
          <span class="icon" v-show="index + 1 != parentInfo.length">></span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import AMapJS from "amap-js";
import resize from "../../mixins/resize";
import echarts4 from "echarts4";
import { getdata } from "@/api/map";
import worldJson from "@/assets/json/world.json";

export default {
  name: "home",
  components: {},
  data() {
    return {
      amapLoader: new AMapJS.AMapLoader({
        key: "7dffec604fbe401935b33f4afb903688",
        version: "1.4.15",
        plugins: [],
      }),
      amapuiLoader: new AMapJS.AMapUILoader({ version: "1.0" }),
      timeTitle: ["2026"],
      parentInfo: [{ cityName: "世界", code: "world", level: "world" }],
      geoJson: { features: [] },
      // 存储接口返回的真实景区数据
      scenicData: [],
      // 后端返回的region数据
      regionData: [],
      chinaCenter: [103.8198, 36.56],
      worldZoom: 3.5,
      // 只允许显示蓝色的三个国家
      allowedCountries: [
        "中国",
        "China",
        "韩国",
        "Korea",
        "Republic of Korea",
        "阿联酋",
        "United Arab Emirates",
        "UAE",
        "美国",
        "United States",
        "US",
        "加拿大",
        "Canada",
        "CA",
      ],
      // 定义行政层级：world > china > province > city > county，最后一级county禁止下钻
      levelMap: {
        world: "china",
        china: "province",
        province: "end",
        city: "end",
        // county: "end" // 标记最后一级
      },
      country: [], // 世界地图存储国家数据
      countryList: [
        { value: '1', label: '中国大陆' },
        { value: '2', label: '中国香港' },
        { value: '3', label: '中国澳门' },
        { value: '4', label: '中国台湾' },
        { value: '5', label: '阿联酋' },
        { value: '6', label: '美国' },
        { value: '7', label: '韩国' },
        { value: '8', label: '加拿大' },
      ],
      // 省份本地假数据已全部注释，改用接口返回
      province: []
    };
  },
  mixins: [resize],
  methods: {
    // 1. 新增：获取真实景区数据并缓存
    async getAllScenic() {
  try {
    const res = await getdata();
    console.log("接口返回景区数据:", res);
    
    this.scenicData = res.data || [];
    this.regionData = res.data.region || [];
    this.country = []; // 清空，避免重复

    // ==================== 核心优化：中国 = 内地+香港+澳门+台湾 ====================
    let chinaTotal = 0;
    const otherCountries = [];

    // 遍历接口返回的地区数据
    this.regionData.forEach(item => {
      const region = Number(item.region);
      const count = Number(item.store_count) || 0;

      // 1/2/3/4 全部算进【中国】总数
      if ([1, 2, 3, 4].includes(region)) {
        chinaTotal += count;
      } 
      // 其他国家单独保存
      else {
        otherCountries.push(item);
      }
    });

    // 把【中国】加入列表
    this.country.push({
      name: "中国",
      code: "100000",
      level: "world",
      store_count: chinaTotal
    });

    // 其他国家根据 countryList 映射名称
    otherCountries.forEach(item => {
      const region = item.region + "";
      const countryItem = this.countryList.find(x => x.value === region);
      if (countryItem) {
        this.country.push({
          name: countryItem.label,
          code: region,
          level: "world",
          store_count: Number(item.store_count) || 0
        });
      }
    });
    // ==========================================================================

    this.getMapData();
  } catch (err) {
    console.error("获取景区数据失败:", err);
    this.scenicData = [];
    this.regionData = [];
    this.country = [];
  }
},

    // 2. 新增：根据adcode获取对应景区数量 + 港澳台走region
    getScenicCountByAdcode(adcode) {
      if (!adcode) return 0;

      // ========== 港澳台：使用后端region数据 ==========
      const regionMap = {
        "810000": 2, // 香港
        "820000": 3, // 澳门
        "710000": 4  // 台湾
      };
      if (regionMap[adcode]) {
        const target = regionMap[adcode];
        let count = 0;
        for (let i = 0; i < this.regionData.length; i++) {
          const item = this.regionData[i];
          if (item.region == target) {
            count = Number(item.store_count);
            break;
          }
        }
        return count;
      }
      // ==============================================

      // 匹配省id
      var provinceItem = this.scenicData.province || [];
      for (var i = 0; i < provinceItem.length; i++) {
        if (provinceItem[i].province_id == adcode) {
          return provinceItem[i].store_count;
        }
      }
      // 匹配市id
      var cityItem = this.scenicData.city || [];
      for (var i = 0; i < cityItem.length; i++) {
        if (cityItem[i].city_id == adcode) {
          return cityItem[i].store_count;
        }
      }
      // 匹配区id
      var areaItem = this.scenicData.area || [];
      for (var i = 0; i < areaItem.length; i++) {
        if (areaItem[i].area_id == adcode) {
          return areaItem[i].store_count;
        }
      }
      // 无数据返回0
      return 0;
    },

    // ================== 新增：读取本地国家/省份数据 ==================
    getLocalStoreCount(level, name) {
      if (level === 'world') {
        var c = this.country.find(function (i) {
          return i.name === name;
        });
        if (c) {
          return c.store_count;
        }
        return 0;
      }
      if (level === 'china') {
        return 0;
      }
      return 0;
    },

    // ================== 核心修复：港澳台强制只保留1个整体 ==================
    async getGeoJson(code) {
      if (code === "world") {
        this.geoJson = JSON.parse(JSON.stringify(worldJson));
        this.getMapData();
        return;
      }

      await this.amapLoader.load();
      await this.amapuiLoader.load();

      let that = this;
      AMapUI.loadUI(["geo/DistrictExplorer"], (DistrictExplorer) => {
        let districtExplorer = new DistrictExplorer();
        districtExplorer.loadAreaNode(code, function (error, areaNode) {
          if (error) {
            console.error(error);
            return;
          }

          // 强制：香港/澳门/台湾 → 只保留1个整体，删掉所有子区
          const hkmt = ["810000", "820000", "710000"];
          if (hkmt.indexOf(code) > -1) {
            // 只取自身轮廓，丢弃所有子区域
            that.geoJson.features = [areaNode.getFeature()];
            // 强制过滤：确保只有1个
            var temp = [];
            for (var i = 0; i < that.geoJson.features.length; i++) {
              var f = that.geoJson.features[i];
              if (f.properties.adcode === code) {
                temp.push(f);
              }
            }
            that.geoJson.features = temp;
            that.getMapData();
            return;
          }

          // 正常地区逻辑不变
          let Json = areaNode.getSubFeatures();
          if (Json.length > 0) {
            that.geoJson.features = Json;
          } else {
            var temp = [];
            for (var i = 0; i < that.geoJson.features.length; i++) {
              var item = that.geoJson.features[i];
              if (item.properties.adcode == code) {
                temp.push(item);
              }
            }
            that.geoJson.features = temp;
            if (that.geoJson.features.length === 0) return;
          }
          that.getMapData();
        });
      });
    },
    // ======================================================================

    isPointInPolygon(point, polygon) {
      const [px, py] = point;
      const [polygonPoints] = polygon;
      let isInside = false;
      let n = polygonPoints.length;
      for (let i = 0, j = n - 1; i < n; j = i++) {
        const [xi, yi] = polygonPoints[i];
        const [xj, yj] = polygonPoints[j];
        const intersect =
          yi > py !== yj > py && px < ((xj - xi) * (py - yi)) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
      }
      return isInside;
    },

    getMapData() {
      let mapData = {},
        pointData = {},
        sum = {};
      for (let i = 0; i < this.timeTitle.length; i++) {
        let time = this.timeTitle[i];
        mapData[time] = [];
        pointData[time] = [];
        sum[time] = 0;
        let last = this.parentInfo.at(-1);
        let level = last.level;

        for (let j = 0; j < this.geoJson.features.length; j++) {
          let feat = this.geoJson.features[j];
          let name = feat.properties.name || feat.properties.NAME || "未知";
          let code = feat.properties.adcode || name;
          let value;

          // ========== 世界地图：使用本地 country 数据 ==========
          if (level === "world") {
            value = this.getLocalStoreCount('world', name);
          }
          // ========== 中国省份、城市、区县：全部使用接口返回数据 ==========
          else {
            value = this.getScenicCountByAdcode(code);
          }

          // ========== 世界地图样式逻辑（保留原逻辑） ==========
          if (level === "world") {
            let isAllow = this.allowedCountries.includes(name);
            let areaColor = "#808080"; // 灰色
            if (isAllow) {
              areaColor = "#24CFF4"; // 蓝色
            }
            let itemStyle = {
              normal: {
                areaColor: areaColor,
                borderColor: "#53D9FF",
                borderWidth: isAllow ? 1.3 : 0.8,
                shadowBlur: isAllow ? 15 : 0,
                shadowColor: isAllow ? "rgb(58,115,192)" : "transparent",
                shadowOffsetX: isAllow ? 7 : 0,
                shadowOffsetY: isAllow ? 6 : 0,
              },
              emphasis: isAllow ? {} : {
                areaColor: "#48494a",    // 同灰色
                borderColor: "#53D9FF",
                borderWidth: 0.8,
                shadowBlur: 0,
                shadowColor: "transparent",
                shadowOffsetX: 0,
                shadowOffsetY: 0,
              }
            };
            
            mapData[time].push({
              name,
              value,
              level,
              cityCode: code,
              itemStyle,
            });
          }
          // ========== 非世界地图样式（保留原逻辑） ==========
          else {
            mapData[time].push({
              name,
              value,
              level,
              cityCode: code,
            });
          }

          pointData[time].push({ name, value: [], cityCode: code });
          sum[time] += value;
        }
        mapData[time].sort((a, b) => b.value - a.value);
      }
      this.drawChinaMap(mapData, pointData, sum);
    },

    drawChinaMap(mapData, pointData, sum) {
      const dom = document.getElementById("chinaMap");
      if (dom._echartsInstance) dom._echartsInstance.dispose();
      let mapChart = echarts4.init(dom);
      dom._echartsInstance = mapChart;

      let last = this.parentInfo.at(-1);

      if (last.level === "world") {
        echarts4.registerMap("world", this.geoJson);
      } else if (last.level === "china") {
        echarts4.registerMap("china", this.geoJson);
      } else {
        echarts4.registerMap("map", this.geoJson);
      }

      let option = {
        graphic: [
          {
            type: "rect",
            z: 0,
            shape: { x: 0, y: 0, width: "100%", height: "100%" },
            style: {
              fill: "linear-gradient(135deg, #0a1929 10%, #112244 100%)",
            },
          },
        ],
        timeline: {
          data: this.timeTitle,
          axisType: "category",
          autoPlay: true,
          playInterval: 3000,
          left: "10%",
          right: "10%",
          bottom: "2%",
          label: {
            normal: { textStyle: { color: "#b3efff" } },
            emphasis: { textStyle: { color: "#fff" } },
          },
          symbolSize: 10,
          lineStyle: { color: "#8df4f4" },
          checkpointStyle: { borderColor: "#8df4f4", color: "#53D9FF" },
          controlStyle: {
            showNextBtn: true,
            showPrevBtn: true,
            normal: { color: "#53D9FF", borderColor: "#53D9FF" },
          },
        },
        baseOption: {
          animation: true,
          tooltip: { trigger: "axis" },
          grid: { right: "2%", top: "12%", bottom: "8%", width: "20%" },
          toolbox: { feature: { dataView: {} }, top: 15, right: 35 },
          geo: {
            map:
              last.level === "world"
                ? "world"
                : last.level === "china"
                ? "china"
                : "map",
            roam: true,
            zoom: last.level === "world" ? this.worldZoom : 1.1,
            center:
              last.level === "world"
                ? this.chinaCenter
                : last.level === "china"
                ? ["118.83531246", "32.0267395887"]
                : false,
            label: {
              normal: {
                show: true,
                color: "#f9f9f9",
                formatter: (p) => {
                  if (
                    last.level === "world" &&
                    this.allowedCountries.indexOf(p.name) === -1
                  )
                    return "";
                  switch (p.name) {
                    case "内蒙古自治区":
                      return "内蒙古";
                    case "西藏自治区":
                      return "西藏";
                    case "新疆维吾尔自治区":
                      return "新疆";
                    case "宁夏回族自治区":
                      return "宁夏";
                    case "广西壮族自治区":
                      return "广西";
                    case "香港特别行政区":
                      return "香港";
                    case "澳门特别行政区":
                      return "澳门";
                    default:
                      return p.name;
                  }
                },
              },
              emphasis: { show: true, color: "#f75a00" },
            },
            itemStyle: {
              normal:
                last.level === "world"
                ? {
                    areaColor: "transparent",
                    borderColor: "transparent",
                    borderWidth: 0,
                  }
                : {
                    areaColor: "#24CFF4",
                    borderColor: "#53D9FF",
                    borderWidth: 1.3,
                    shadowBlur: 15,
                    shadowColor: "rgb(58,115,192)",
                    shadowOffsetX: 7,
                    shadowOffsetY: 6,
                  },
              emphasis: {
                areaColor: "#8dd7fc",
                borderWidth: 1.6,
                shadowBlur: 25,
              },
            },
          },
        },
        options: [],
      };

      this.timeTitle.forEach((time) => {
        let xData = [],
          yData = [];
        let list = mapData[time];
        let min = 0;
        let max = 100;
        if (list.length > 0) {
          min = Math.min.apply(Math, list.map(function (i) { return i.value }));
          max = Math.max.apply(Math, list.map(function (i) { return i.value }));
        }

        list.forEach((c) => {
          if (last.level === "world") {
            if (this.allowedCountries.indexOf(c.name) > -1) {
              xData.unshift(c.name);
              yData.unshift(c.value);
            }
          } else {
            xData.unshift(c.name);
            yData.unshift(c.value);
          }
        });

        option.options.push({
          title: [
            {
              left: "center",
              top: 0,
              text: `${time} ${last.cityName} 景区统计图(可点击下钻到市/区)`,
              textStyle: { color: "#b3efff", fontSize: 16 },
            },
            {
              text: `景区总览：${sum[time].toFixed(0)}个`,
              left: "center", top: "6.5%",
              textStyle: { color: "#FFAC50", fontSize: 26 },
            },
          ],
          // 世界地图关闭颜色条，其他正常显示
          visualMap:
            last.level == "world"
              ? {
                  show: false,
                  min: 0,
                  max: 100,
                  inRange: {
                    color: ["#808080", "#2E98CA", "#1E62AC", "#FFAC50"],
                  },
                  calculable: true,
                }
              : {
                  min: min,
                  max: max,
                  left: "3%",
                  bottom: "5%",
                  calculable: true,
                  inRange: { color: ["#24CFF4", "#2E98CA", "#1E62AC"] },
                  textStyle: { color: "#24CFF4" },
                },
          xAxis: {
            type: "value", scale: true, position: "top",
            splitLine: { show: false },
            axisLine: { lineStyle: { color: "#455B77" } },
            axisLabel: { color: "#c0e6f9" },
          },
          yAxis: {
            type: "category",
            axisLine: { lineStyle: { color: "#455B77" } },
            axisLabel: { color: "#c0e6f9" },
            data: xData,
          },
          series: [
            {
              type: "map",
              geoIndex: 0,
              map:
                last.level === "world"
                  ? "world"
                  : last.level === "china"
                  ? "china"
                  : "map",
              roam: true,
              zoom: last.level === "world" ? this.worldZoom : 1.3,
              tooltip: {
                formatter: (p) => {
                  if (
                    last.level === "world" &&
                    this.allowedCountries.indexOf(p.name) === -1
                  )
                    return "";
                  if (!p.value || p.name === "南海诸岛") return p.name;
                  if (p.name === "中国" && last.level === "world") {
                    return `<div style='text-align:left'>${p.name}<br/>点击进入中国景区详情</div>`;
                  }
                  return `<div style='text-align:left'>${p.name}<br/>景区：${p.value.toFixed(0)}个</div>`;
                },
              },
              label: { normal: { show: false }, emphasis: { show: false } },
              data: mapData[time],
            },
            {
              type: "effectScatter",
              coordinateSystem: "geo",
              data:
                last.level === "world"
                  ? pointData[time].filter(function (item) {
                      return this.allowedCountries.indexOf(item.name) > -1;
                    }.bind(this))
                  : pointData[time],
              symbolSize: function(val) {
                if (val && val[2] === max) {
                  return 27;
                } else {
                  return 10;
                }
              },
              label: { normal: { show: false } },
              itemStyle: { color: "#F4E925" },
            },
            {
              type: "bar",
              barGap: "-100%",
              barCategoryGap: "60%",
              itemStyle: { color: "#11AAFE" },
              data: yData,
            },
          ],
        });
      });

      mapChart.setOption(option, true);
      mapChart.off("click");
      mapChart.on("click", this.echartsMapClick);
      window.addEventListener("resize", () => mapChart.resize());
    },

    // 3. 核心改造：关闭最后一级下钻 + 香港澳门禁止下钻
    echartsMapClick(params) {
      let last = this.parentInfo[this.parentInfo.length - 1];
      // 世界地图层：仅允许点击中国下钻
      if (last.level === "world") {
        if (!params.data || this.allowedCountries.indexOf(params.data.name) === -1)
          return;
      }
      if (!params.data) return;
      let { name, cityCode } = params.data;
      if (last.code === cityCode) return;

      // ================== 新增：香港、澳门禁止下钻（跟台湾一样整体） ==================
      var specialAreas = [
        "香港", "香港特别行政区",
        "澳门", "澳门特别行政区",
        "台湾", "台湾省"
      ];
      if (specialAreas.indexOf(name) > -1) {
        console.log("特殊地区（香港/澳门/台湾），禁止下钻，保持整体显示");
        return;
      }
      // ==========================================================================

      // 新增：判断当前层级是否为最后一级，禁止下钻
      const nextLevel = this.levelMap[last.level];
      if (nextLevel === "end") {
        console.log("已到最后一级（县级），禁止下钻");
        return;
      }

      // 世界地图下钻到中国
      if (last.level === "world") {
        if (name === "中国" || name === "China") {
          this.parentInfo.push({
            cityName: "中国",
            code: 100000,
            level: "china",
          });
          this.getGeoJson(100000);
        }
        return;
      }

      // 其他层级正常下钻（china→province→city→county，county后禁止）
      this.parentInfo.push({ 
        cityName: name, 
        level: nextLevel, 
        code: cityCode 
      });
      this.getGeoJson(cityCode);
    },

    chooseArea(val, index) {
      if (this.parentInfo.length === index + 1) return;
      this.parentInfo.splice(index + 1);
      const dom = document.getElementById("chinaMap");
      if (dom._echartsInstance) dom._echartsInstance.dispose();
      this.$nextTick(() => {
        this.getGeoJson(this.parentInfo[this.parentInfo.length - 1].code);
      });
    },

    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    getRandomFloat(min, max, decimalPlaces) {
      const factor = Math.pow(10, decimalPlaces);
      return (Math.random() * (max - min) + min).toFixed(decimalPlaces);
    },
    generateRandomData(numRecords) {
      const data = [];
      const minLat = -53,
        maxLat = 72;
      const minLon = -180,
        maxLon = 180;
      for (let i = 0; i < numRecords; i++) {
        data.push({
          areaCode: this.getRandomInt(10000, 99999).toString(),
          areaName: `Area ${this.getRandomInt(1, 100)}`,
          center: `${this.getRandomFloat(
            minLat,
            maxLat,
            6
          )},${this.getRandomFloat(minLon, maxLon, 6)}`,
          store_count: this.getRandomInt(1, 10),
        });
      }
      return data;
    },
    getinfodata(){}
  },
  mounted() {
    // 先获取真实数据，再初始化地图
    this.getAllScenic().then(() => {
      this.getinfodata();
      this.getGeoJson("world");
    });
  },
};
</script>

<style lang="scss" scoped>
.map {
  position: relative;
  background-color: rgba(1, 34, 72, 0.5) !important;
  background-image: url("https://invengo-card.oss-cn-shanghai.aliyuncs.com/cd157f2b7d32a21acf060c55255da8bd.gif") !important;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  width: 100%;
  height: 100%;
}
.app-container {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  #chinaMap {
    width: 100%;
    height: 800px;
    background: none !important;
  }
  .mapChoose {
    position: absolute;
    left: 20px;
    top: 20px;
    color: rgb(147, 235, 248);
    z-index: 100;
    .title {
      padding: 5px;
      border-top: 1px solid rgba(147, 235, 248, 0.8);
      border-bottom: 1px solid rgba(147, 235, 248, 0.8);
      cursor: pointer;
    }
    .icon {
      font-family: "simsun";
      font-size: 25px;
      margin: 0 11px;
    }
  }
}
</style>